module.exports = __webpack_public_path__ + "static/tvr-img-b0afdf35efa5898f24a44cdfafd532b7.png";